/**
 * Checkbox component created by karora on 19/06/17.
 */
import {Component, Input, ViewChild} from "@angular/core";
import {NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {ElementBase} from "./element.base";

@Component({
  moduleId: module.id,
  selector: 'checkbox',
  template:
`<div class="container">
  <label *ngIf="label">{{label}}</label>
  <div class="checkbox">
    <input
          type="checkbox" 
          [(ngModel)]="value"
          [id]="identifier"
          [class.checked]="value"/>
    <label
     [attr.for]="identifier" 
     [class.checked]="value"></label>
  </div>
</div>
`,
  styles: [`
.checkbox {
  display: inline-block;
	width: 25px;
	margin: 0;
	position: relative;
}
.checkbox label {
	cursor: pointer;
	position: absolute;
	width: 25px;
	height: 25px;
	top: 0;
  left: 0;
	background: #eee;
	border:1px solid #ddd;
}
.checkbox label:after {
	opacity: 0.2;
	content: url("/images/unchecked.svg");
	position: absolute;
	top: 0;
	left: 0;
	background: transparent;
	border: none;
}
.checkbox label:hover::after {
	opacity: 0.5;
}
.checkbox input[type=checkbox] + label:after {
	color: black;
}
.checkbox input[type=checkbox]:checked + label:after {
	opacity: 1;
}
.checkbox label.checked {
  background: #4070a0;
}
.checkbox label.checked:after {
	content: '';
	width: 12px;
	height: 6px;
	top: 5px;
	left: 5px;
  border: 4px solid white;
	border-top: none;
	border-right: none;

	transform: rotate(-45deg);
}
.container {
  display: inline-block;
}
`
  ],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: CheckboxComponent, multi: true}
  ],
})

export class CheckboxComponent extends ElementBase<boolean> {
  @Input() public label: string;
  @Input() public placeholder: string;

  @ViewChild(NgModel) model: NgModel;

  public identifier: any = `form-checkbox-${identifier++}`;

  onClick(v: boolean) {
    this.value = !this.value;
    console.log("New valule: " + this.value + ": " + v);
  }
}

let identifier = 0;
